import { getDevIdentity, isDevLoginEnabled } from './devLogin';
import { useSession } from './useSession';

/**
 * Resolves the signed-in user's email — the same value the BE records as a
 * custom element's `author` (see `RequireAuthorEmail`'s `email ?? preferred_username`
 * claim chain). Used purely to split "mine" from "everyone else" in custom-element
 * lists; the BE's own mine-first ordering doesn't need this, but the FE divider does.
 */
export function useCurrentUserEmail(): string | null {
  if (isDevLoginEnabled()) {
    const identity = getDevIdentity();
    // BE's RequireAuthorEmail prefers the `email` claim (which DevLoginAuthHandler
    // emits from DevLoginIdentities.All) over `preferred_username` — match that here,
    // falling back to the `{oid}@dev.local` shape only if an identity has no email.
    return identity ? (identity.email ?? `${identity.oid}@dev.local`) : null;
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { user } = useSession();
  return user?.email ?? user?.preferred_username ?? null;
}
